module.exports = __webpack_public_path__ + "img/reload.34eb1fd6.svg";